// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ArrowBackIos } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { BlockContainer, Loader } from '../../../../../../../components';
import {
  VoucherHistory,
  RedemptionHistory,
} from '../components';

import * as customerOverviewActions from '../store/actions';
import {
  getLoader,
  getBookshopCustomer,
} from '../store/selectors';

import styles from './styles';


class CustomerOverview extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.bool,
    bookshopCustomer: PropTypes.object,

    getBookshopCustomer: PropTypes.func,
    resetForm: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    history: {},
    match: {},
    loading: false,
    bookshopCustomer: {},

    getBookshopCustomer: () => { },
    resetForm: () => { },
  };

  componentDidMount() {
    this.props.resetForm();
    const { history, match } = this.props;

    const CustomerId = localStorage.getItem('loggedID');
    const Token = localStorage.getItem('token');

    // The :id in the path is the source of truth, with the router state kept
    // only as a fallback. It used to be the other way round - the path was
    // decorative and the id came from state the Link carried - so reloading
    // the page or opening the link in a new tab threw on undefined state, and
    // the URL could not be shared or bookmarked.
    const bookshopCustomerId = (match && match.params && match.params.id)
      || ((history.location.state || {}).bookshopCustomerId);

    this.props.getBookshopCustomer({
      CustomerId,
      Token,
      Id: bookshopCustomerId,
    });
  }


  render() {
    const {
      classes,
      history,
      loading,
      bookshopCustomer,
    } = this.props;

    // No confirm dialog here any more - it only ever confirmed the pooled
    // redemption that has been removed, so nothing could open it. The Redeem
    // voucher screen has its own confirmation.
    return (
      <div className={classes.root}>
        {loading
          ? (
            <div className={classes.loaderContainer}>
              <Loader />
            </div>
          ) : (
            <div>
              <div
                role={'button'}
                tabIndex={0}
                onKeyPress={() => history.goBack()}
                onClick={() => history.goBack()}
                className={classes.arrowBackContainer}
              >
                <ArrowBackIos className={classes.link} />
                <div className={classes.link}>Back</div>
              </div>
              {/* The 'Redeem voucher' box that used to sit here spent the
                  customer's pooled balance, which the backend retired in
                  favour of per-voucher balances - so it addressed something
                  that no longer exists and silently did nothing. Redemption
                  now happens against a specific voucher, on the Redeem
                  voucher screen, which is reachable from the Vouchers tab. */}
              <div className={classes.blockContainer}>
                <BlockContainer
                  topText={'Gift voucher history'}
                  bottom={<VoucherHistory vouchers={bookshopCustomer.Vouchers} />}
                />
              </div>
              <div className={classes.blockContainer}>
                <BlockContainer
                  topText={'Redemption history'}
                  bottom={<RedemptionHistory balanceLogs={bookshopCustomer.BalanceLogs} />}
                />
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: getLoader(state),
    bookshopCustomer: getBookshopCustomer(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBookshopCustomer: payload => dispatch(customerOverviewActions.getBookshopCustomer(payload)),
    resetForm: () => dispatch(customerOverviewActions.resetForm()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CustomerOverview));
